import React, { Fragment, useEffect, useState } from "react";
import "./App.css";
import Portfolio from "./pages/Portfolio";
import { CursorTwo } from "cursor-style";
import { CookiesProvider } from "react-cookie";
import { AudioProvider } from "./components/AudioContext";
import click from "./sounds/click.mp3";
import beep from "./sounds/beep.mp3";
import hover from "./sounds/hover.mp3";
import water from "./sounds/water.mp3";
import pop from "./sounds/pop.mp3";
import flip from "./sounds/flip.mp3";
import rotate from "./sounds/rotate.mp3";
import open from "./sounds/open.mp3";

function App() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, []);

  return (
    <AudioProvider
      soundFile={click}
      beepFile={beep}
      hoverFile={hover}
      waterFile={water}
      popFile={pop}
      flipFile={flip}
      rotateFile={rotate}
      openFile={open}
    >
      <CookiesProvider>
        <Fragment>
          {isMobile && (
            <CursorTwo
              size={15}
              delay={5}
              sizeDot={10}
              sizeOutline={25}
              bgColorDot="white"
              bgColorOutline="white"
            />
          )}
          <Portfolio />
        </Fragment>
      </CookiesProvider>
    </AudioProvider>
  );
}

export default App;
